export default __webpack_public_path__ + "static/relative-book-regular-e94d68b7975391691185bcbe3fe2bb24.woff";